import artifacts from "./artifacts";
import build from "./build";
import presets from "./presets";
import uploads from "./uploads";
import configs from "./configs";
import gcsim from "./gcsim";

export default { artifacts, build, presets, uploads, configs, gcsim };
